module.exports = __webpack_public_path__ + "01f43047/img/upload-icon.9179ae4e.svg";